/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PublisherQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PublisherQueryOperator");
    }

    getFixupPrototypeFunction() { return PublisherQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PublisherQueryOperator>): PublisherQueryOperator {
        let obj = Object.assign(new PublisherQueryOperator(), model);
        PublisherQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PublisherQueryOperator>): PublisherQueryOperator {
        if (!model) return null;
        return PublisherQueryOperator.newInstance(<PublisherQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PublisherQueryOperator) {
        if (!obj) return;

        models.PublisherQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PublisherQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PublisherQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Publishers to include
     */
    publishers: Array<string>;

}
